var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncident(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7071 1.69797C17.2871 0.712006 18.7129 0.712007 19.2929 1.69797L35.6703 29.5395C36.2585 30.5395 35.5375 31.8 34.3774 31.8H1.62264C0.462512 31.8 -0.25847 30.5395 0.329737 29.5395L16.7071 1.69797ZM19.34 26.5598C19.34 27.2667 18.7669 27.8398 18.06 27.8398C17.3531 27.8398 16.78 27.2667 16.78 26.5598C16.78 25.8529 17.3531 25.2798 18.06 25.2798C18.7669 25.2798 19.34 25.8529 19.34 26.5598ZM18.06 12C17.3531 12 16.78 12.5731 16.78 13.28V22.72C16.78 23.427 17.3531 24 18.06 24C18.7669 24 19.34 23.427 19.34 22.72V13.28C19.34 12.5731 18.7669 12 18.06 12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncident);
export default __webpack_public_path__ + "static/media/incident.1f10f23cc92d320067f3f34414223258.svg";
export { ForwardRef as ReactComponent };